import { MapboxError, MapboxTileSourceError } from "./errors-types";

/**
 * Checks a MapboxError to see if it is a MapboxTileSourceError
 */
export function isMapboxTileSourceError(event: MapboxError): event is MapboxTileSourceError {
    if (event == null || typeof event !== "object") {
        return false;
    }

    const isError = "type" in event && event.type === "error";
    if (!isError) {
        return false;
    }

    const hasSourceId = "sourceId" in event && typeof event.sourceId === "string";
    if (!hasSourceId) {
        return false;
    }

    const hasSoruce = "source" in event && typeof event.source === "object" && event.source != null;
    if (!hasSoruce) {
        return false;
    }

    return true;
}
